import axios from 'axios';

class PayfastPaymentsService {

    async getPaymentDetails(companyId, invoiceId, signature) {
        console.log("[PayfastPaymentsService][getPaymentDetails] Getting payment details for invoiceId ", invoiceId);
        return await axios.get(`/api/payfast/pay/${companyId}/${invoiceId}/${signature}`);
    }

    async getPaymentStatus(paymentReference) {
        console.log("[PayfastPaymentsService][getPaymentStatus] Getting payment status for paymentReference ", paymentReference);
        return await axios.get(`/api/payfast/pay/status/${paymentReference}`);
    }

    async getPaymentDetailsWithAmount(companyId, amount) {
        console.log("[PayfastPaymentsService][getPaymentDetailsWithAmount] Getting payment details for amount ", amount);
        return await axios.get(`/api/payfast/pay/amount/${companyId}/${amount}`);
    }
}

export default new PayfastPaymentsService();
